import React, { useState } from "react";
import { DashboardLayout } from "./Dashboard";
import TableWithSearch from "@/components/TableWithSearch";
import { requestTableHeaders } from "@/utils/tablesData";
import { Eye } from "lucide-react";
import { Dialog } from "@/components/ui/dialog";
import MyDialogContent from "@/components/MyDialogContent";
import RHFWrapper from "@/components/RHFWrapper";
import RhfInput from "@/components/rhfFields/RhfInput";
import { Button } from "@/components/ui/button";
import { useFormContext } from "react-hook-form";
import { getPromise, getPromiseToast } from "@/utils/helpers";
import AxiosInstance from "@/utils/AxiosInstance";


const OptOutPatients = () => {
  const [patient, setPatient] = useState([]);
  const [review, setReview] = useState(false);
  const [load, setLoad] = useState(false);
  async function reviewRequest(formdata: any, isApproved: any) {
    const { pr, rejectFn, resolveFn } = getPromise();
    setLoad(true)
    getPromiseToast(pr);
    try {
      if (!formdata?.reviewNotes || formdata?.reviewNotes?.length == 0) {
        throw new Error("Review notes is required");
      }
    const {data} :any =   await AxiosInstance().put("/program-removal/review/" + review, {
        ...formdata,
        action: isApproved ? "approved" : "rejected",
      });
      resolveFn("Request reviewed successfully");
      setPatient((prev:any) => 
        prev
      .filter((v:any)=> v?._id !== review)
      // .map((item: any) => {
      //   if (item._id === review) {
      //   return data?.data?.removalRequest
      //   }
      //   return item;
      // })
    );
      setReview(false);
    } catch (error) {
      rejectFn(error);
    }
    finally{
      setLoad(false)
    }
  }

  return (
    <DashboardLayout activePage="/opt-out">
      <TableWithSearch
        isColumnSelection
        columnPreferenceKey="opt-out-patients-requests"
        clickRow={() => {}}
        data={patient}
        setData={setPatient}
        viewData={(patient || []).map((item: any) => ({
          _id: item._id,
          program: item.program,
          reason: item.reason,
          status: item.status,
          createdAt: item.createdAt,
          updatedAt: item.updatedAt,

          // patient
          patientId: item.patientId?._id,
          patientFirstName: `${item.patientId?.firstName || ""}  ${item.patientId?.lastName}`,
          patientLastName: item.patientId?.lastName,
          patientEmail: item.patientId?.email,
          patientPatientId: item.patientId?.patientId,

          // requestedBy
          requestedById: item.requestedBy?._id,
          requestedByName: item.requestedBy?.name,
          requestedByEmail: item.requestedBy?.email,
        }))}
        searchPlaceholder="Search patients..."
        apiDataKey="requests"
        url="/program-removal/all"
        columnHeaders={requestTableHeaders}
        isIncludeSearch
        fetchCondition={true}
        filters={[]}
        filtersOptions={[]}
        handleAction={() => {}}
        heading=""
        isActionColumn={false}
        params={{status : "pending"}}
        setFilters={() => {}}
        moreActions={[
          {
            label: "View",
            onClick: (data) => {
              setReview(data?._id);
            },
            icon: <Eye />,
            isShow: (data) => data?.status == "pending",
          },
        ]}
      />
      <Dialog open={!!review} onOpenChange={setReview}>
        <MyDialogContent className="md:w-md" heading="Review Opt out request">
          <RHFWrapper
            initialValues={{}}
            isValidate={false}
            validateSchema={{}}
            className="space-y-3"
            onSubmit={() => {}}
          >
            <RhfInput type="textarea" name="reviewNotes" label="Review Note" />
            <Btn reviewRequest={reviewRequest} btnLoad={load} />
          </RHFWrapper>
        </MyDialogContent>
      </Dialog>
    </DashboardLayout>
  );
};

const Btn = ({ reviewRequest,btnLoad }: any) => {
  const { getValues } = useFormContext();
  return (
    <div className="flex items-center gap-2">
      <div className="flex-1">
        <Button
          type="button"
          onClick={() => reviewRequest(getValues(), false)}
          className="w-full"
          variant={"destructive"}
          disabled={btnLoad}
        >
          Reject
        </Button>{" "}
      </div>
      <div className="flex-1">
        <Button
          type="button"
          onClick={() => reviewRequest(getValues(), true)}
          className="w-full"
          disabled={btnLoad}

        >
          Approve
        </Button>{" "}
      </div>
    </div>
  );
};

export default OptOutPatients;
